import React from 'react'
import ClosePlayer from '../../AudioPlayerComponents/ClosePlayer'
import PlayerCollapse from '../../AudioPlayerComponents/PlayerCollapse'
import PlayerExpand from '../../AudioPlayerComponents/PlayerExpand'
import PlayerSource from '../../AudioPlayerComponents/PlayerSource'
import SongBackward from '../../AudioPlayerComponents/SongBackward'
import SongCover from '../../AudioPlayerComponents/SongCover'
import SongForward from '../../AudioPlayerComponents/SongForward'
import SongPlayPause from '../../AudioPlayerComponents/SongPlayPause'
import SongSlider from '../../AudioPlayerComponents/SongSlider'
import SongTime from '../../AudioPlayerComponents/SongTime'
import SongTitle from '../../AudioPlayerComponents/SongTitle'
import SongVolume from '../../AudioPlayerComponents/SongVolume'

function AudioPlayer() {
  
  return (
    <div id="audio-player-container" style={{display: "none"}}>
      <div id="audio-player" style={{display: "none"}}>
        <SongCover />
        <SongPlayPause />
        <SongBackward />
        <PlayerSource />
        <SongTitle />
        <SongSlider />
        <SongTime />
        <SongForward />
        <SongVolume />
        <PlayerExpand />
        <PlayerCollapse />
        <ClosePlayer />
      </div>
    </div>
  )
}

export default AudioPlayer